import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'filters-dropdown',

})

export default class FiltersDropdown extends Vue {

    // -------------------------------------------------------------
    // Properties

    @Prop({ type: Array, required: true })
    public filters: any;

    public selectedOptions: any = [];

    // -------------------------------------------------------------
    // Methods

    public selectOption(type: any, option: any) {
        if (!this.selectedOptions) {
            this.selectedOptions = {};
        }
        this.selectedOptions[type.key] = option;
        this.$emit('onSelectFilters', this.selectedOptions);
    }

    public clearSelection(filterName: string) {
        if (this.selectedOptions && filterName in this.selectedOptions) {
            delete this.selectedOptions[filterName];
            this.$emit('clearFilter', filterName);
        }
    }
}
